export default "__VITE_ASSET__iTkEN$Hj__"